/* -- Byimaan -- */

import React, { useEffect, useState } from 'react';
import './style.scss';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useParams } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import { fetchData } from '../../utils/api';
import ContentWrapper from '../../components/contentWrapper/ContentWrapper';
import MovieCard from '../../components/movieCard/MovieCard';
import Spinner from '../../components/spinner/Spinner';
import Select from 'react-select';


let filters = {};

const sortByData = [
  { value: "popularity.desc", label: "Popularity Descending" },
  { value: "popularity.asc", label: "Popularity Ascending" },
  { value: "vote_average.desc", label: "Rating Descending" },
  { value: "vote_average.asc", label: "Rating Ascending" },
  {
      value: "primary_release_date.desc",
      label: "Release Date Descending",
  },
  { value: "primary_release_date.asc", label: "Release Date Ascending" },
  { value: "original_title.asc", label: "Title (A-Z)" },
];



const Explore = () => {

  const [data,setData] = useState(null);
  const [pageNum, setPageNum] = useState(1);
  const [loading,setLoading] = useState(false);
  const [genre,setGenre] = useState(null);
  const [sortby,setSortby] = useState(null);
  const {mediaType} = useParams();

  const [ genresData ] = useFetch(`/genre/${mediaType}/list`);

  const fetchInitialData = () => {
    setLoading(true);

    fetchData(`/discover/${mediaType}`,filters).then( res => {
      setData(res);
      setPageNum( prev => prev + 1);
      setLoading(false);
    });
  }

  const fetchNextPageData = () => {
    fetchData(`/discover/${mediaType}?page=${pageNum}`,filters).then ( res => {
      if (data?.results){
        setData( {
          ...data,
          results: [...data?.results, ...res?.results],
        })
      } else {
        setData(res);
      }
    });

    setPageNum( prev => prev + 1);
  };

  const handleChange = (selectedItems,action) => {
    if (action.name === 'sortby'){
      setSortby(selectedItems);

      if (action.action !== 'clear'){
        filters.sort_by = selectedItems.value;
      } else {
        delete filters.sor_by;
      }
    } else if (action.name === 'genres'){
      setGenre(selectedItems);
      
      if (action.action !== 'clear'){
        let genreId = selectedItems.map( g => g.id);
        genreId = JSON.stringify(genreId).slice(1,-1);
        filters.with_genres = genreId;
      } else {
        delete filters.with_genres;
      }
    };

    setPageNum(1);
    fetchInitialData();
  };

  useEffect( () => {
    filters = {};
    setData(null);
    setPageNum(1);
    setSortby(null);
    setGenre(null);

    fetchInitialData();
  },[mediaType]);

  return (
    <div className="explorePage">
      <ContentWrapper>
        <div className="pageHeader">

          <div className="pageTitle">
            {
              mediaType === 'tv' ? 'Explore TV Shows' : 'Explore Movies'
            }
          </div>
          <div className="filters">
            <Select 
               isMulti
               name='genres'
               value={genre}
               closeMenuOnSelect={false}
               options={genresData?.genres}
               getOptionLabel={ option => option.name}
               getOptionValue={ option => option.id}
               onChange={handleChange}
               placeholder='Select genres'
               className='react-select-container genresDD'
               classNamePrefix='react-select'
            />

            <Select 
               name='sortby'
               value={sortby}
               options={sortByData}
               isClearable={true}
               onChange={handleChange}
               placeholder='Sort by'
               className='react-select-container sortbyDD'
               classNamePrefix='react-select'
            />
          </div>

        </div>

        { 
          loading ? <Spinner/> : (
            <React.Fragment>
              {
                (data?.results?.length ?? 0) > 0 ? (
                  <InfiniteScroll
                     className='content'
                     dataLength={data?.results?.length || 0}
                     next={fetchNextPageData}
                     hasMore={pageNum <= data?.total_pages ?? 0}
                     loader={<Spinner/>}
                  >
                    {
                      data?.results?.map( (item,index) => {
                        if (item?.mediaType === 'person') {
                          return null;
                        } else {
                          return (
                            <MovieCard 
                              key={index}
                              data={item}
                              mediaType={mediaType}
                            />
                          );
                        };
                      })
                    }   

                  </InfiniteScroll>  

                ) : (
                  <span className="resultNotFound"> Sorry, Results not Found...</span>
                )
              }
            </React.Fragment>
          )
        }

      </ContentWrapper>
    </div>
  )
}

export default Explore;

